export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-3830557f705aa0d7559b03269c942fe4.svg";